import React from 'react';
import { Calendar, RefreshCw } from 'lucide-react';
import '../../TeamManagement/TeamManagement.css';
import { Button } from '@/shared/components/atoms/Button/Button';

interface PreCallHeaderProps {
  onSync: () => void;
  isSyncing: boolean;
}

export function PreCallHeader({ onSync, isSyncing }: PreCallHeaderProps) {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between', 
      flexWrap: 'wrap', 
      gap: '20px', 
      marginBottom: '24px' 
    }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 style={{ 
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'var(--admin-card-text)', 
          fontSize: '37.9px', 
          fontWeight: 700, 
          margin: '0 0 6px', 
          letterSpacing: '-0.76px',
          lineHeight: '38px'
        }}>
          Pre-Call Intelligence
        </h1>
        <p style={{ 
          fontFamily: "'Inter', sans-serif",
          color: '#7C8891', 
          fontSize: '14px', 
          margin: 0, 
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '0'
        }}>
          Import your upcoming sales meetings automatically. Generate on-demand AI dossiers for any call.
        </p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="ghost"
          onClick={onSync}
          disabled={isSyncing}
          title="Import the latest meetings from your connected calendar"
          leftIcon={<RefreshCw size={14} className={isSyncing ? 'animate-spin' : ''} />}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            backgroundColor: '#ffffff',
            color: '#1a1a1a',
            border: '1px solid var(--admin-card-border)',
            borderRadius: '0',
            padding: '0 16px',
            fontWeight: 600,
            fontSize: '13px',
            cursor: 'pointer',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            width: 'auto',
            height: '36px',
          }}
          className="hover:bg-gray-50 active:scale-95 disabled:opacity-50"
        >
          {isSyncing ? 'Fetching...' : 'Fetch Meetings'}
        </Button>
      </div>
    </div>
  );
}
